<template>
  <vs-card class="pl-5 pt-5 pr-1 m-0">
    <div>
      <a href="#" @click="$emit('changeTab','ComponentGeneral')">
        <h4 class="title-report font-semibold">Accounts Receivable</h4>
      </a>
      <p class="text-base font-medium">Report of outstanding receivables. <a href="#"></a></p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentAgentRecivable')">
        <h4 class="title-report font-semibold">Accounts Receivable Aging</h4>
      </a>
      <p class="text-base font-medium">Report of accounts receivable broken up by periods of time. <a href="#"></a></p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentHistoryBill')">
        <h4 class="title-report font-semibold">Billing History</h4>
      </a>
      <p class="text-base font-medium	">Report of both current and past bills.<a href="#"></a></p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentMatterBalanceSummery')">
        <h4 class="title-report font-semibold">Matter Balance Summary</h4>
      </a>
      <p class="text-base font-medium	">Summary of all open matters with outstanding receivables and work in progress.<a href="#"></a></p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentInvoicePayments')">
        <h4 class="title-report font-semibold">Invoice Payments Report</h4>
      </a>
      <p class="text-base font-medium">A general ledger of payments made on invoices. Includes corresponding credits on each item
        of service and expense.<a href="#"></a>
      </p>
    </div>
  </vs-card>
</template>

<script>
export default {
name: "BillingReport"
}
</script>

<style scoped>

</style>
